const addToClassroomButton = document.getElementById('add-to-classroom-button');
const addToSyllabusButton = document.getElementById('add-to-syllabus-button');
const classroomsModal = document.getElementById('classrooms-modal');
const bottomToolbar = classroomsModal.querySelector('.bottom-toolbar');
const cancelButton = classroomsModal.querySelector('.cancel-button');
const finishButton = classroomsModal.querySelector('.finish-button');
const contentContainer = classroomsModal.querySelector('.content-container');
const addToClassroomsHeader = classroomsModal.querySelector('.header');
const pageContent = document.getElementById('page-content');
const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
const isSyllabusEmbed = document.querySelector('body').classList.contains('syllabus-embed');
const classroomSelectionStorageSet = new Set();

addToClassroomButton.addEventListener('click', openModal);
cancelButton.addEventListener('click', closeModal);
finishButton.addEventListener('click', submitClassrooms);
addToSyllabusButton.addEventListener('click', submitForSyllabus);

function renderAddToClassroomPage(classroomId = null) {
    const selectedResources = getSelectedResources();
    const resourcesCountLabel = selectedResources.length === 1 ? '1 resource' : `${selectedResources.length} resources`;
    addToClassroomsHeader.textContent = `Add ${resourcesCountLabel} to your classrooms`;

    const apiRequest = () => axios.get('/v3/classrooms');
    
    const onSuccess = response => {
        contentContainer.innerHTML = response.data;

        document.getElementById('create-classroom-button').addEventListener('click', () => {
            renderCreateClassroomForm();
        });

        contentContainer.addEventListener('click', (event) => {
            if (event.target.classList.contains('classroom-checkbox')) {
                handleCheckboxClick();
            }
        });

        initializeClassroomSelections();
        selectNewClassroomAndScrollIntoView(classroomId);
        disableClassroomsContainingAllSelections(selectedResources);
        showFinishButton();
        showBottomToolbarButton();

        const archivedClassroomsToggle = classroomsModal.querySelector('#archived-classroom-list-toggle');
        const anArchivedClassroomIsSelected = archivedClassroomIsSelected();

        if (anArchivedClassroomIsSelected) {
            turnArchivedToggleOn();
        }

        if (archivedClassroomsToggle) {
            archivedClassroomsToggle.disabled = anArchivedClassroomIsSelected;
        }

        $('#archived-classroom-list').on('shown.bs.collapse', scrollArchivedClassroomListIntoView);
    };

    const animations = {startLoadingAnimation, stopLoadingAnimation};
    
    submitApiRequest({apiRequest, onSuccess, onAuthError, animations});
}

function turnArchivedToggleOn() {
    const archivedToggle = document.getElementById('archived-classroom-list-toggle');
    const archivedList = document.getElementById('archived-classroom-list');

    archivedToggle.checked = true;
    archivedToggle.classList.remove('collapsed');
    archivedToggle.setAttribute('aria-expanded', true);
    archivedList.classList.add('show');
}

function openModal() {
    renderAddToClassroomPage();

    modal.open(classroomsModal, () => {
        hideFinishButton();
        disableFinishButton();
    });
}

function selectNewClassroomAndScrollIntoView(classroomId) {
    if (classroomId) {
        document.getElementById(`classroom-${classroomId}`).click();

        const classroomOption = document.getElementById(`classroom-option-${classroomId}`);
        classroomOption.scrollIntoView({block: "nearest", inline: "nearest", behavior: 'smooth'});
    }
}

function scrollArchivedClassroomListIntoView() {
    const archivedList = document.getElementById('archived-classroom-list');
    archivedList.scrollIntoView({block: "nearest", inline: "nearest", behavior: 'smooth'});
}

function disableClassroomsContainingAllSelections(selectedResources)
{
    const classrooms = [...classroomsModal.querySelectorAll('.classroom-option')];

    classrooms.forEach(classroom => {
        const alreadyAddedResourceIds = classroom.dataset.alreadyAddedResourceIds.split(',');
        const disable = selectedResources.every(id => alreadyAddedResourceIds.indexOf(id) > -1);
        
        if (disable) {
            classroom.classList.add('disabled');
            classroom.querySelector('input[type="checkbox"]').disabled = true;
        }
    });
}

function closeModal() {
    modal.close(classroomsModal, () => {
        contentContainer.innerHTML = '';
        setButtonText(cancelButton, 'Cancel');
        classroomsModal.classList.remove('show-success-confirmation');
        hideFinishButton();
        classroomSelectionStorageSet.clear();
    });
}

function handleCheckboxClick() {
    const selectedClassrooms = storeSelectedClassrooms();
    if (selectedClassrooms.length > 0) {
        enableFinishButton();
    } else {
        disableFinishButton();
    }

    const archiveToggle = classroomsModal.querySelector('#archived-classroom-list-toggle');

    if (archiveToggle) {
        archiveToggle.disabled = archivedClassroomIsSelected() && archiveToggle.checked;
    }
}

function renderCreateClassroomForm() {
    hideBottomToolbarButton();

    const apiRequest = () => axios.get('/v3/classrooms/create');

    const onSuccess = response => {
        contentContainer.innerHTML = response.data;
        document.getElementById('classroom-name').focus();
        initializeDatePickers();
        handleCancelCreateClassroom();
        handleSubmitCreateClassroom();
    };

    const animations = {startLoadingAnimation, stopLoadingAnimation};

    submitApiRequest({apiRequest, onSuccess, onAuthError, animations});

    function handleCancelCreateClassroom() {
        document.getElementById('cancel-create-classroom-button').addEventListener('click', () => {
            renderAddToClassroomPage();
            disableFinishButton();
        });
    }

    function handleSubmitCreateClassroom() {
        document.getElementById('create-classroom-and-continue-button').addEventListener('click', () => {
            if (!formValidated()) {
                return;
            }

            const name = document.getElementById('classroom-name').value;
            const begin_date = document.getElementById('begin-date').value;
            const end_date = document.getElementById('end-date').value;
            const apiRequest = () => axios.post('/v3/classrooms/store', {name, begin_date, end_date});

            const onSuccess = (response) => {
                renderAddToClassroomPage(response.data.classroomId);
            };

            const onError = ({error, openErrorModal}) => {
                enableCreateClassroomSubmitButton();

                if (typeof(error.response.data.errors) === 'undefined') {
                    openErrorModal();
                    return;
                }

                hidePreviousInvalidFeedback();
                addInvalidFeedback(error.response.data.errors);
            };


            disableCreateClassroomSubmitButton();

            submitApiRequest({apiRequest, onSuccess, onError, onAuthError});
        });

        function formValidated() {
            let validForm = true;
            const name = document.getElementById('classroom-name');
            const beginDate = document.getElementById('begin-date');
            const endDate = document.getElementById('end-date');

            if (name.value === '') {
                name.classList.add('is-invalid');
                validForm = false;
            } else {
                name.classList.remove('is-invalid');
            }
            if (beginDate.value === '') {
                beginDate.classList.add('is-invalid');
                validForm = false;
            } else {
                beginDate.classList.remove('is-invalid');
            }
            if (endDate.value === '') {
                endDate.classList.add('is-invalid');
                validForm = false;
            } else {
                endDate.classList.remove('is-invalid');
            }

            return validForm;
        }

        function hidePreviousInvalidFeedback() {
            document.querySelectorAll('#create-classroom-form .form-control').forEach((input) => {
                input.classList.remove('is-invalid');
            });
        }

        function addInvalidFeedback(errors) {
            const {name: classroomName, begin_date: beginDate, end_date: endDate} = errors;

            if (classroomName) {
                document.getElementById('classroom-name').classList.add('is-invalid');
                document.querySelector('#classroom-name ~ .invalid-feedback').innerHTML = classroomName.join('<br />');
            }

            if (beginDate) {
                document.getElementById('begin-date').classList.add('is-invalid');
                document.querySelector('#begin-date ~ .invalid-feedback').innerHTML = beginDate.join('<br />');
            }

            if (endDate) {
                document.getElementById('end-date').classList.add('is-invalid');
                document.querySelector('#end-date ~ .invalid-feedback').innerHTML = endDate.join('<br />');
            }
        }
    }

    function disableCreateClassroomSubmitButton() {
        const spinnerHtml = '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>';
        const submitButton = document.getElementById('create-classroom-and-continue-button');
        submitButton.innerHTML = spinnerHtml;
        submitButton.disabled = true;
    }

    function enableCreateClassroomSubmitButton() {
        const submitButton = document.getElementById('create-classroom-and-continue-button');
        submitButton.innerHTML = 'Create and Continue';
        submitButton.disabled = false;
    }
}

function submitClassrooms() {
    const classrooms = getClassroomSelections();
    if (classrooms.length === 0) {
        return;
    }

    disableFinishButton();

    const apiRequest = () => axios.get('/v3/resource-gallery/session');
    const onAuthError = () => {
        window.location.href = '/resource-gallery';
    }
    const onSuccess = () => {
        submit();
    }
    const sessionAnimations = {startLoadingAnimation};

    submitApiRequest({apiRequest, onAuthError, onSuccess, sessionAnimations});

    function submit () {
        const resources = getSelectedResources();

        const apiRequest = () => axios.post('/imp.php?classroom=42&controller=add-resources', {classrooms, resources});

        const onSuccess = (response) => {
            window.selections.selections.clear();

            addToClassroomsHeader.textContent = response.data.data.header;
            contentContainer.innerHTML = response.data.data.message;

            hideFinishButton();
            setButtonText(cancelButton, 'Close');
            classroomsModal.classList.add('show-success-confirmation');
        };

        const onError = ({openErrorModal}) => {
            openErrorModal();
            enableFinishButton();
        };

        const animations = {startLoadingAnimation, stopLoadingAnimation};

        submitApiRequest({apiRequest, onSuccess, onError, onAuthError, animations});
    }
}

function submitForSyllabus() {
    const filters = [{
        type: 'selected_resource',
        selectedOptions: getSelectedResources(),
    }];

    const apiRequest = () => axios.post('/v3/resource-gallery/review', {filters, showFilters: false});

    const onSuccess = response => {
        const resources = response.data.resources.map(resource => ({
            id: buildItemIdForSyllabus(resource),
            gallery_resource_id: resource.id,
            title: resource.title,
            thumb: resource.thumbnail,
            type_name: resource.type_name,
            syllabus_item_type: resource.syllabus_item_type
        }));

        addResourcesToSyllabus({resources, csrfToken});
    };

    const animations = {startLoadingAnimation, stopLoadingAnimation};
    
    submitApiRequest({apiRequest, onSuccess, onAuthError, animations});
}

function buildItemIdForSyllabus(resource) {
    if (resource.syllabus_item_type === 'written_assessment' || resource.syllabus_item_type === 'syllabus') {
        return `${resource.type_alias}_${resource.uid}`
    }

    return `${resource.uid || resource.id}`;
}

function addResourcesToSyllabus(detail) {
    const event = buildAddResourcesToSyllabusEvent(detail);
    window.parent.document.dispatchEvent(event);

    window.selections.selections.clear();
}

function buildAddResourcesToSyllabusEvent(detail) {
    if (typeof(Event) === 'function') {
        return new CustomEvent('add_resources_to_syllabus', {detail});
    }

    // Workaround for Internet Explorer 11
    const event = document.createEvent('CustomEvent');
    event.initCustomEvent('add_resources_to_syllabus', true, true, detail);
    return event;
}

function startLoadingAnimation() {
    if (isSyllabusEmbed) {
        pageContent.classList.add('loading', 'disabled');
    } else {
        classroomsModal.classList.add('loading');
    }
}

function stopLoadingAnimation() {
    if (isSyllabusEmbed) {
        pageContent.classList.remove('loading', 'disabled');
    } else {
        classroomsModal.classList.remove('loading');
    }
}

function showFinishButton() {
    bottomToolbar.classList.add('show-finish-button');
    setTimeout(() => setButtonText(finishButton, 'Finish Adding'), 300);
}

function hideFinishButton() {
    setButtonText(finishButton, '');
    bottomToolbar.classList.remove('show-finish-button');
}

function hideBottomToolbarButton() {
    bottomToolbar.classList.add('d-none');
}

function showBottomToolbarButton() {
    bottomToolbar.classList.remove('d-none');
}

function enableFinishButton() {
    finishButton.disabled = false;
    finishButton.classList.remove('disabled');
}

function disableFinishButton() {
    finishButton.disabled = true;
    finishButton.classList.add('disabled');
}

function setButtonText(button, text) {
    button.textContent = text;
}

function storeSelectedClassrooms() {
    classroomSelectionStorageSet.clear();

    [...contentContainer.querySelectorAll('.classroom-checkbox:checked')].map((input) => {
        classroomSelectionStorageSet.add(input.value);
    });

    return getClassroomSelections();
}

function getSelectedResources() {
    return selections.getSelections();
}

function onAuthError() {
    window.location.href = '/resource-gallery';
}

function initializeDatePickers() {
    const datePickerOptions = {
        container: '#classrooms-modal',
        format: 'm/d/yyyy',
        formatSubmit: 'yyyy-mm-dd',
        onClose: function() {
            document.activeElement.blur();
        },
    };
    const beginDateInput = $('#begin-date').pickadate(datePickerOptions);
    const beginDatePicker = beginDateInput.pickadate('picker');
    const endDateInput = $('#end-date').pickadate(datePickerOptions);
    const endDatePicker = endDateInput.pickadate('picker');

    addMinAndMaxDateConstraints();

    function addMinAndMaxDateConstraints() {
        // Check if there is a "begin" or "end" date to start with.
        if (beginDatePicker.get('value')) {
            endDatePicker.set('min', beginDatePicker.get('select'));
        }
        if (endDatePicker.get('value')) {
            beginDatePicker.set('max', endDatePicker.get('select'));
        }

        // When something is selected, update the "begin" and "end" limits.
        beginDatePicker.on('set', function (event) {
            if (event.select) {
                endDatePicker.set('min', beginDatePicker.get('select'));
            } else if ('clear' in event) {
                endDatePicker.set('min', false);
            }
        });
        endDatePicker.on('set', function (event) {
            if (event.select) {
                beginDatePicker.set('max', endDatePicker.get('select'));
            } else if ('clear' in event) {
                beginDatePicker.set('max', false);
            }
        });
    }
}

function initializeClassroomSelections() {
    if (classroomSelectionStorageSet.size === 0) {
        return;
    }

    enableFinishButton();

    for(let selection of classroomSelectionStorageSet) {
        document.getElementById(`classroom-${selection}`).checked = true;
    }
}

function archivedClassroomIsSelected() {
    const archivedClassrooms = [...classroomsModal.querySelectorAll('#archived-classroom-list .classroom-checkbox')];

    for(let classroom of archivedClassrooms) {
        if (classroom.checked) {
            return true;
        }
    }

    return false;
}

function getClassroomSelections() {
    return [...classroomSelectionStorageSet.values()];
}
